import { render, staticRenderFns } from "./SalesMonitor.vue?vue&type=template&id=64c04006&scoped=true"
import script from "./SalesMonitor.vue?vue&type=script&lang=js"
export * from "./SalesMonitor.vue?vue&type=script&lang=js"
import style0 from "./SalesMonitor.vue?vue&type=style&index=0&id=64c04006&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c04006",
  null
  
)

export default component.exports